export default __webpack_public_path__ + "static/media/vp_update.64898f0b.png";